import { render } from "./원내배치도.vue?vue&type=template&id=0db44001"
import script from "./원내배치도.vue?vue&type=script&lang=js"
export * from "./원내배치도.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__